import { render, staticRenderFns } from "./DadosdoSubordinado.vue?vue&type=template&id=42dc18ba&scoped=true"
import script from "./DadosdoSubordinado.vue?vue&type=script&lang=js"
export * from "./DadosdoSubordinado.vue?vue&type=script&lang=js"
import style1 from "./DadosdoSubordinado.vue?vue&type=style&index=1&id=42dc18ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc18ba",
  null
  
)

export default component.exports